<template>
	<div class="flex flex-col h-auto min-h-screen max-h-screen w-full bg-green-90">
		<div class="w-full px-5 md:px-10 lg:px-32 xl:px-64 pt-4 pb-3 bg-grey-600 text-green-300 text-3xl sm:text-4xl shadow-2xl">
			<a @click="goBack" @keypress.enter="goBack" tabindex="0" class="cursor-pointer">
				<svg class="inline-block align-middle mr-1 -mt-1" width="30" height="30" viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path d="M19.375 23.25L11.625 15.5L19.375 7.75" class="stroke-current" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
				</svg>
			</a>
			
			Get Exploring
		</div>
		<div class="px-5 md:px-10 lg:px-32 xl:px-64 pt-5 pb-32 text-body text-white text-xl overflow-x-hidden overflow-y-auto">
			<div v-if="error" class="-mt-6 mb-4 mb-1 pt-5 pb-4 -mx-5 md:-mx-10 lg:-mx-32 xl:-mx-64 px-5 md:px-10 lg:px-32 xl:px-64 bg-red-500 text-white text-xl font-body">
				{{ error }}
			</div>
			
			<div v-if="false">
				<p class="block font-body text-green-900 leading-tight text-2xl">As a free user, all your challenge attempts must start in Hyde Park.</p>
				<div class="block h-px w-full bg-grey-800 mt-4 mb-4"></div>
			</div>
			
			<h4 class="block text-green-800 text-2xl -mb-1">Challenge a friend</h4>
			<div class="mt-2">
				<input @keypress.enter="start" class="block w-full font-sans rounded-none bg-transparent text-green-800 placeholder-green-600 border-8 border-solid border-grey-600 px-2 py-2 text-2xl" type="text" placeholder="Enter their trip code..." v-model="share_code" />
			</div>
			<p class="text-xl text-green-1000 leading-tight font-body pt-4">Visit the same places as your friends, to try and beat their score.</p>
			
			<div class="flex mt-3 mb-2">
				<div class="flex-grow block h-px w-full bg-grey-400 mt-4 mb-4"></div>
				<span class="px-3 align-middle text-grey-600 pt-1">OR</span>
				<div class="flex-grow block h-px w-full bg-grey-400 mt-4 mb-4"></div>
			</div>
			
			<h4 class="block text-green-800 text-2xl -mb-1">Number of checkpoints</h4>
			<div class="flex px-2 sm:px-10 md:px-12 lg:px-16">
				<div class="w-1/4 p-4 m-6 ml-0 md:m-12 md:ml-2 relative">
					<a :class="{'opacity-25': checkpoint_count == 3, 'pointer-events-none': checkpoint_count == 3}" @click="decreaseCheckpoints" @keypress.enter="decreaseCheckpoints" tabindex="0" class="absolute w-full rounded-lg align-middle cursor-pointer" style="top: 50%; left: 50%; transform: translate(-50%, -50%); padding-bottom: 40%;">
						<span class="block absolute text-5xl text-grey-600" style="top: 50%; left: 50%; transform: translate(-50%, -50%);">-</span>
					</a>
				</div>
				<div class="w-1/2 py-4 -mx-5 md:px-4 md:mx-0">
					<div class="w-full bg-green-300 text-grey-600 py-3 text-center text-5xl border-8 border-solid border-grey-600">{{ checkpoint_count }}</div>
				</div>
				<div class="w-1/4 p-4 m-6 mr-0 md:m-12 md:mr-2 relative">
					<a :class="{'opacity-25': checkpoint_count == 9, 'pointer-events-none': checkpoint_count == 9}" @click="increaseCheckpoints" @keypress.enter="increaseCheckpoints" tabindex="0" class="absolute w-full rounded-lg align-middle cursor-pointer" style="top: 50%; left: 50%; transform: translate(-50%, -50%); padding-bottom: 40%;">
						<span class="block absolute text-5xl text-grey-600" style="top: 50%; left: 50%; transform: translate(-50%, -50%);">+</span>
					</a>
				</div>
			</div>
			
			<h4 class="block text-green-800 text-2xl -mb-1">Pick a theme</h4>
			<p v-if="themes.length == 0" class="text-white text-xl font-body leading-tight pt-2">{{ themes_message }}</p>
			<div v-if="themes.length > 0">
				<a v-for="theme in themes" :key="theme.name" @click="selectTheme(theme.code)" @keypress.enter="selectTheme(theme.code)" tabindex="0" class="block mt-3 px-3 pt-3 pb-2 border-8 border-solid border-green-600 cursor-pointer" :class="{'bg-green-300': selected_theme == theme.code, 'border-grey-600': selected_theme == theme.code, 'bg-green-90': selected_theme != theme.code}">
					<h6 class="text-green-900 font-body font-bold" :class="{'text-grey-600': selected_theme == theme.code}" style="font-size: 1.4rem;">{{ theme.name }}</h6>
					<p v-if="selected_theme == theme.code" class="text-green-1000 font-body text-xl leading-tight">{{ theme.description }}</p>
				</a>
			</div>
		</div>
		
		<a @click="start" @keypress.enter="start" tabindex="0" class="fixed bottom-0 left-0 w-full font-sans border-none bg-red-600 text-red-80 text-3xl text-center leading-tight py-4 sm:py-8 no-underline shadow-md cursor-pointer">
			LET'S GO!
		</a>
		
		<locationrequest v-if="showLocationRequest" />
	</div>
</template>

<style>

</style>

<script>
import Storages from 'js-storage';
import axios from 'axios';
import LocationRequest from '../components/LocationRequest.vue';

export default {
	name: 'Plan',
	path: '/plan',
	components: {
		'locationrequest': LocationRequest
	},
	data() {
		return {
			error: null,
			storage: null,
			share_code: '',
			checkpoint_count: 5,
			selected_theme: 'random',
			themes_message: "Loading themes...",
			themes: [],
			key: '',
			user: {
				id: 0,
				username: '',
				email: '',
				premium: false
			},
			location: null,
			online_config: {},
			showLocationRequest: false
		}
	},
	created() {
		this.storage = Storages.localStorage;
		
		if (!this.storage.isSet('session_key')) {
			this.$router.push("/welcome");
			return;
		}
		
		if (this.storage.isSet('active_challenge')) {
			this.$router.replace("/challenge");
			return;
		}
		
		this.online_config = this.storage.get('online_config');
		this.getCurrentUser();
		this.getMostRecentThemes();
		
		var that = this;
		window.onmessage = function(event) {
			if (event.data.type == "location") {
				console.log("Received location data:");
				console.log(event.data);
				that.location = event.data.location;
			}
		}
	},
	methods: {
		goBack() {
			if (window.history.length == 1) {
				this.$router.replace("/");
				return;
			}
			
			this.$router.go(-1);
		},
		async getLocation() {
			return new Promise((resolve, reject) => {
				if(!("geolocation" in navigator)) {
					reject(new Error('Your browser does not support geolocation'));
				}
				
				navigator.geolocation.getCurrentPosition(pos => {
					resolve({
						latitude: pos.coords.latitude,
						longitude: pos.coords.longitude
					});
				}, err => {
					reject(err);
				});
			});
		},
		async locationCheck(result) {
			return new Promise(async (resolve, reject) => {
				switch (result.state) {
					case "prompt":
						this.showLocationRequest = true;
						resolve(null);
						break;
					case "denied":
						reject("You denied us access to your location. Please allow it in browser settings to play.");
						break;
					default:
						resolve(await this.getLocation());
						break;
				}
			});
		},
		async checkLocationPermission() {
			var that = this;
			return new Promise((resolve, reject) => {
				try {
					if (this.online_config.test_access_only !== true) {
						navigator.permissions.query({name:'geolocation'}).then(async (result) => {
							that.locationCheck(result)
							.then(location => {
								resolve(location);
							})
							.catch(error => {
								reject(error);
							});
						});
					} else {
						resolve(that.location);
					}
				} catch(e) {
					var err = e.message;
					
					if (err == "User denied Geolocation") {
						err = "You denied us access to your location. Please allow it in browser settings to play.";
					}
					
					reject(err);
				}
			});
		},
		async start() {
			this.error = "";
			var that = this;
			this.checkLocationPermission()
			.then(location => {
				that.location = location;
				
				if (that.location == null) {
					return;
				}
				
				that.create();
			})
			.catch(error => {
				that.error = error;
			});
		},
		async create() {
			if (this.location == null) {
				return;
			}
			
			var that = this;
			axios.get('https://bakerstreet.arturs.co.uk/api/lostinthecity/trip/create?key=' + this.key + '&length=' + this.checkpoint_count + '&code=' + this.share_code + '&theme=' + this.selected_theme + '&lat=' + this.location.latitude + '&long=' + this.location.longitude)
			.then(function (response) {
				var data = response.data;
				
				if (data.success == true) {
					that.storage.set('route', data.response.checkpoints);
					that.storage.set('estimated_distance', data.response.estimated_distance);
					that.storage.set('estimated_time', data.response.estimated_time);
					that.$router.replace('/start');
				} else {
					that.error = data.response;
				}
			})
			.catch(function (error) {
				if (error.response) {
					var data = error.response.data;
					that.error = data.response;
				} else {
					that.error = "An unknown error has occured.";
				}
			});
		},
		getCurrentUser() {
			if (this.storage.isSet('route')) {
				this.$router.replace('/start');
			} else {
				this.key = this.storage.get('session_key');
				this.user = this.storage.get('authed_user');
				this.route = this.storage.get('route');
				this.estimated_distance = this.storage.get('estimated_distance');
				this.estimated_time = this.storage.get('estimated_time');
			}
		},
		getMostRecentThemes() {
			var that = this;
			axios.get('https://bakerstreet.arturs.co.uk/api/lostinthecity/themes?city=' + that.user.city)
			.then(function (response) {
				var data = response.data;
				
				if (data.success == true) {
					that.themes = data.response.themes;
				} else {
					that.themes_message = data.response;
				}
			})
			.catch(function (error) {
				if (error.response) {
					var data = error.response.data;
					that.themes_message = data.response;
				} else {
					that.themes_message = "An unknown error has occured.";
				}
			});
		},
		increaseCheckpoints(e) {
			e.preventDefault();
			
			if (this.checkpoint_count == 9) {
				return;
			}
			
			if (this.user.premium == true) {
				this.checkpoint_count++;
			} else {
				this.$router.push('/premium');
			}
		},
		decreaseCheckpoints(e) {
			e.preventDefault();
			
			if (this.checkpoint_count == 3) {
				return;
			}
			
			if (this.user.premium == true) {
				this.checkpoint_count--;
			} else {
				this.$router.push('/premium');
			}
		},
		selectTheme(code) {
			if (this.user.premium == true) {
				this.selected_theme = code;
			} else {
				this.$router.push('/premium');
			}
		}
	}
}
</script>